import React from 'react';
import { useTranslation } from 'react-i18next';
import robot_cancel from '../images/robot_cancel.svg';
import './unsubscribed.scss';

const Unsubscribed = () => {
  const params = new URL(window.location).searchParams;
  const email = params.get('email');
  const templateName = params.get('name');
  const { t } = useTranslation();

  const decodeHex = (hex = '') => {
    let result = '';
    for (let i = 0; i < hex.length; i += 2) {
      const hexPair = hex.substr(i, 2);
      const decimalValue = parseInt(hexPair, 16);
      const asciiChar = String.fromCharCode(decimalValue);
      result += asciiChar;
    }
    return result;
  };

  const getTemplateMessages = () => {
    if (templateName === 'all') {
      return {
        title: t('{{decodedEmail}} has been unsubscribed from all our educational contexts.', {
          decodedEmail: decodeHex(email),
        }),
        description: t('You may still receive system critical messages (such as password resets!).'),
      };
    }

    return {
      title: t('{{decodedEmail}} has been unsubscribed from {{templateName}}.', {
        decodedEmail: decodeHex(email),
        templateName,
      }),
      description: t(
        'You may still receive system critical messages (such as password resets!) and email for other educational contexts.'
      ),
    };
  };

  const messages = getTemplateMessages();

  return (
    <div className="foundry unsubscribe-page">
      <h2>{t('There you go!')}</h2>
      <p>{messages.title}</p>
      <div className="inner-content">
        <img src={robot_cancel} alt={'Unsubscription'} className="img-error img-fluid m-30" />
        <p>{messages.description}</p>
      </div>
    </div>
  );
};

export default Unsubscribed;
